import React from "react";
import { Button, Typography } from "@material-ui/core";
import Modal from "../../Modal/Modal";
import * as styles from "./referralDenyModal.module.css";

const ReferralDenyModal = ({ open, handleClose, handleSubmit }) => {
    return (
        <Modal visible={open} close={handleClose}>
            <div className={styles.confirmContainer}>
                <Typography variant="h4">Are you sure?</Typography>
                <Typography>This action will deny this person their Referral credit. (You will have to email them to tell them so).</Typography>
                <div className={styles.actionContainer}>
                    <Button variant="contained"
                        color="secondary"
                        size="small"
                        onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button variant="contained"
                        color="primary"
                        size="small"
                        onClick={handleSubmit} >
                        Deny
                    </Button>
                </div>
            </div>

        </Modal>
    );
};

export default ReferralDenyModal;
